import ApiService from '@/services/api.service';
const getLocationValues = (type) => {
    const params = {};
    // const sql = "SELECT * from oil_locations where type = 'state'";
    const sql = `SELECT month, "Location" as location, "Date", sum(num(value)) AS value from orr_delay_minutes where option_2 = '${type}' GROUP BY month, "Date", "Location" order by "Location" ASC, "Date" ASC`;
    params.sql = window.btoa(sql);
    params.pre = 1;
    params.totalItems = 10000;
    params.rowsPerPage = 10000;
    return ApiService.query('/datasource/sql/' + 979, { params })
  }

  const getFeatures = (attr1, attr2) => {
    const params = {};
    // const sql = "SELECT * from oil_locations where type = 'state'";
    const sql = `SELECT *  from orr_delay_minutes_features where attribute = '${attr1}' or attribute = '${attr2}' order by entity ASC`;
    params.sql = window.btoa(sql);
    params.pre = 1;
    params.totalItems = 10000;
    params.rowsPerPage = 10000;
    return ApiService.query('/datasource/sql/' + 979, { params })
  }

  export {
    getLocationValues,
    getFeatures,
  }